import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTimeAgo(date: Date): string {
  try {
    const now = new Date();
    const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (isNaN(diffInMinutes)) {
      return '';
    }

    if (diffInMinutes < 60) {
      return `${diffInMinutes} min ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`;
    } else {
      return `${diffInDays} day${diffInDays === 1 ? '' : 's'} ago`;
    }
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
}

// Simple hash function for creating consistent identifiers
export function simpleHash(input: string): string {
  let hash = 0;
  if (input.length === 0) return hash.toString(16);
  
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Convert to hex string and ensure it's 32 chars long
  const hexHash = Math.abs(hash).toString(16).padStart(8, '0').repeat(4).substring(0, 32);
  return hexHash;
}

// Create a Gravatar URL from an email
export function gravatarUrl(email: string, size: number = 200): string {
  const normalizedEmail = email.trim().toLowerCase();
  const hash = simpleHash(normalizedEmail);
  return `https://www.gravatar.com/avatar/${hash}?d=identicon&s=${size}`;
}

// Create a profile picture URL with fallbacks
export function getProfilePictureUrl(picture: string | undefined | null, email: string | undefined | null): string {
  if (picture) {
    return picture;
  }
  
  if (email) {
    return gravatarUrl(email);
  }
  
  // Default fallback
  return 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y';
}
